module.exports = __webpack_public_path__ + "img/img3.6b7fd70f.png";